module.exports = __webpack_public_path__ + "img/gntech_main2.2a7d454e.jpg";